import apiClient from './apiClient';

export interface AlertSettings {
  id: string;
  ownerId: string;
  discordWebhookEnabled: boolean;
  discordWebhookUrl: string | null;
  telegramWebhookEnabled: boolean;
  telegramBotToken: string | null;
  telegramChatId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateAlertSettingsRequest {
  discordWebhookEnabled?: boolean;
  discordWebhookUrl?: string;
  telegramWebhookEnabled?: boolean;
  telegramBotToken?: string;
  telegramChatId?: string;
}

export interface TelegramChannel {
  id: string;
  title: string;
  type: string;
  displayName: string;
}

export const alertSettingsService = {
  async getSettings(): Promise<AlertSettings> {
    const response = await apiClient.get('/alert-settings');
    return response.data;
  },

  async updateSettings(data: UpdateAlertSettingsRequest): Promise<AlertSettings> {
    const response = await apiClient.put('/alert-settings', data);
    return response.data;
  },

  async sendTestDiscordWebhook(): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post('/alert-settings/test-discord-webhook');
    return response.data;
  },

  async sendTestTelegramWebhook(): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post('/alert-settings/test-telegram-webhook');
    return response.data;
  },

  async getTelegramChannels(botToken: string): Promise<TelegramChannel[]> {
    const response = await apiClient.get('/alert-settings/telegram-channels', {
      params: { botToken },
    });
    return response.data;
  },
};
